import React from "react";

export default function Impressions({ site }) {
  const stats = site.stats || [];
  return (
    <section
      data-testid="impressions-section"
      id="studio"
      className="relative bg-[#050505] border-t border-white/10"
    >
      <div className="px-5 sm:px-8 lg:px-12 py-20 lg:py-28">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="overline">О нас</p>
            <h2 className="font-display mt-3 uppercase whitespace-pre-line text-2xl sm:text-3xl lg:text-4xl leading-[1] tracking-tight">
              {site.impressions_title}
            </h2>
          </div>
          <p className="max-w-md text-white/65 text-sm sm:text-base leading-relaxed">
            {site.impressions_body}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
          {stats.map((s, i) => (
            <div
              key={s.label + i}
              data-testid={`impressions-stat-${i}`}
              className="bg-[#050505] p-5 sm:p-6 flex flex-col justify-between min-h-[160px] sm:min-h-[180px]"
            >
              <span className="font-display bbf-accent-text leading-none tracking-tight text-4xl sm:text-5xl lg:text-6xl">
                {s.value}
              </span>
              <span className="text-xs sm:text-sm text-white/55 mt-3 leading-snug">
                {s.label}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-3 text-white/55 text-xs sm:text-sm">
          <span className="font-mono-jb uppercase tracking-[0.22em] text-white/40">
            География
          </span>
          <span>Москва</span>
          <span className="text-white/20">·</span>
          <span>Санкт-Петербург</span>
          <span className="text-white/20">·</span>
          <span>Екатеринбург</span>
        </div>
      </div>
    </section>
  );
}
